module.exports = __webpack_public_path__ + "static/raleway-latin-400-131f660715196288a68bd84296ada895.woff2";